/**
 * Web half of the api package's per-repo bindings. NOT synced — the app repo ships its own
 * version on its own parser, so `response.ts` stays byte-identical across both.
 */

/** The `<title>` of an html error page. Throws when the body will not parse — the caller falls back. */
export const parseHtmlTitle = async (html: string): Promise<string | undefined> => {
  const { DOMParser } = await import('@xmldom/xmldom')
  const parser = new DOMParser({ onError: () => {} })
  const doc = parser.parseFromString(html, 'text/html')
  return doc.getElementsByTagName('title')?.[0]?.textContent ?? undefined
}
